import { render, staticRenderFns } from "./MarginRecharge.vue?vue&type=template&id=9535b2c0&scoped=true&"
import script from "./MarginRecharge.vue?vue&type=script&lang=js&"
export * from "./MarginRecharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9535b2c0",
  null
  
)

export default component.exports